import React, { useMemo } from "react";
import { ThreeDots } from 'react-loader-spinner';
import { makeStyles } from 'tss-react/mui';
const convertSizeToDimensions = (size) => {
    switch (size) {
        case 'sm':
            return { height: 30, width: 30 };
        case 'md':
            return { height: 30, width: 60 };
        case 'lg':
            return { height: 30, width: 90 };
        case 'xl':
            return { height: 30, width: 120 };
    }
};
const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export const Loader = ({ size = 'md', ...loaderProps }) => {
    const { classes, theme } = useStyles();
    const dimensions = useMemo(() => convertSizeToDimensions(size), []);
    return (React.createElement("div", { className: classes.container },
        React.createElement(ThreeDots, { color: theme.palette.iisightBrand, ...dimensions, ...loaderProps })));
};
